export default __webpack_public_path__ + "static/media/apple-touch-icon-120x120.6aa7d4f1.png";